import axios from "axios";

// Appels API en chemin relatif : ils partent du MÊME domaine que la page
// (o-crea.ch, www.o-crea.ch, domaine Emergent, localhost) → aucune requête
// cross-origin, donc aucun blocage CORS quelle que soit la variante du domaine.
// L'ingress redirige automatiquement /api vers le backend (port 8001).
export const API = "/api";

// Origines connues ayant pu être stockées en dur dans des URLs d'assets
// (ancienne DB, anciens builds, domaine custom avec/sans www)
const KNOWN_ORIGINS = [
  "https://custom-goods-15.preview.emergentagent.com",
  "https://custom-goods-15.emergent.host",
  "https://o-crea.ch",
  "https://www.o-crea.ch",
];

// Rend une URL d'asset indépendante du domaine : supprime toute origine connue
// pour ne garder que le chemin "/api/..." servi par le domaine courant.
export const fixUrl = (u) => {
  if (!u || typeof u !== "string") return u;
  let out = u.trim();
  for (const o of KNOWN_ORIGINS) {
    if (out.startsWith(o)) {
      out = out.slice(o.length);
      break;
    }
  }
  return out;
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Fallback Bearer quand le navigateur bloque les cookies tiers (iframe, Safari strict…).
// Les tokens sont aussi renvoyés dans le corps des réponses login/register/google.
export const ADMIN_TOKEN_KEY = "ocrea_admin_token";
export const CUSTOMER_TOKEN_KEY = "ocrea_session_token";

api.interceptors.request.use((config) => {
  const url = config.url || "";
  const customerToken = localStorage.getItem(CUSTOMER_TOKEN_KEY);
  const adminToken = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (url.startsWith("/account")) {
    if (customerToken) config.headers.Authorization = `Bearer ${customerToken}`;
  } else if (adminToken) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  }
  return config;
});

export const fileUrl = (path) => fixUrl(`/api/files/${String(path).replace(/^\/api\/files\//, "")}`);

export const PLACEHOLDER_IMG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='500'%3E%3Crect width='100%25' height='100%25' fill='%23EAE6DF'/%3E%3Ctext x='50%25' y='50%25' font-family='Georgia, serif' font-size='30' fill='%237A7A7A' text-anchor='middle' dominant-baseline='middle'%3Eo-crea%3C/text%3E%3C/svg%3E";

export const imgSrc = (u) => {
  const s = u && String(u).trim();
  if (!s) return PLACEHOLDER_IMG;
  if (s.startsWith("data:")) return s;
  return fixUrl(s);
};

export const fontLabel = (f) => {
  if (!f) return "";
  const first = String(f).split(",")[0].replace(/['"]/g, "").trim();
  return first || String(f);
};

export const chf = (n) =>
  new Intl.NumberFormat("fr-CH", { style: "currency", currency: "CHF" }).format(n);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
